// extracted by mini-css-extract-plugin
module.exports = {"BaseLayout":"BaseLayout_BaseLayout__Pr5dB","BaseLayout__Footer":"BaseLayout_BaseLayout__Footer__NDVB9"};